import { z } from 'zod';
import { extendZodWithOpenApi } from '@hono/zod-openapi';
import 'zod-openapi/extend';
extendZodWithOpenApi(z);

export const GmodBranchSchema = z
	.object({
		branch: z.enum(['unknown', 'dev', 'prerelease', 'x86-64']).openapi({
			example: 'unknown',
			description: 'Branch of the player',
		}),
	})
	.openapi({ ref: 'Gmod Branch' });

export type GmodBranchInput = z.infer<typeof GmodBranchSchema>;
